import { useMemo, useState } from "react";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { View } from "@common/types/views/views";
import styles from "./HistoryDetails.module.scss";
import {
    createDefaultHistoryInvoiceTemplateChangeView,
    createDefaultHistoryInvoiceTemplateContentView,
} from "./invoiceTemplates/views/defaultHistoryInvoiceTemplateDetailsView";
import {
    HistoryInvoiceTemplateChangeRow,
    HistoryInvoiceTemplateContentRow,
    createHistoryInvoiceTemplateChangeViewConfig,
    createHistoryInvoiceTemplateContentViewConfig,
} from "./invoiceTemplates/views/historyInvoiceTemplateDetailsViewConfig";

const EMPTY_HEADER = "No invoice template changes found";

interface HistoryInvoiceTemplateChangeDetailsProps {
    data: HistoryInvoiceTemplateChangeRow[];
    footer: React.ReactNode;
}

export const HistoryInvoiceTemplateChangeDetails: React.FC<
    HistoryInvoiceTemplateChangeDetailsProps
> = ({ data, footer }) => {
    const [view, setView] = useState<View>(
        createDefaultHistoryInvoiceTemplateChangeView(),
    );
    const viewConfig = useMemo(
        () => createHistoryInvoiceTemplateChangeViewConfig(data),
        [data],
    );

    return (
        <ViewTable
            data={data}
            view={view}
            config={viewConfig}
            onViewChange={setView}
            emptyView={() => <EmptyState header={EMPTY_HEADER} />}
            footer={footer}
            className={styles.historyDetailsView}
        />
    );
};

interface HistoryInvoiceTemplateContentDetailsProps {
    data: HistoryInvoiceTemplateContentRow[];
    footer: React.ReactNode;
}

export const HistoryInvoiceTemplateContentDetails: React.FC<
    HistoryInvoiceTemplateContentDetailsProps
> = ({ data, footer }) => {
    const [view, setView] = useState<View>(
        createDefaultHistoryInvoiceTemplateContentView(),
    );
    const viewConfig = useMemo(
        () => createHistoryInvoiceTemplateContentViewConfig(),
        [],
    );

    return (
        <ViewTable
            data={data}
            view={view}
            config={viewConfig}
            onViewChange={setView}
            emptyView={() => <EmptyState header={EMPTY_HEADER} />}
            footer={footer}
            className={styles.historyDetailsView}
        />
    );
};
